import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseOrderReopenAtom = createMutationAtomFactory(
  'trade.purchaseOrderReopen',
  (params: { id: string }) => ({
    tradePurchaseOrderReopen: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      documentNumber: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
